import axios from 'axios'
import Constants from '../constants'

export default {
  getAnalytics: (event, action, note, token) => {
    return new Promise((resolve, reject) => {
      const params = {
        id: Constants.API_ID,
        areaId: Constants.API_ID,
        event: event,
        action: action,
        note: note,
        token: token
      }

      axios.get('analytics', { params })
        .then(() => {
          resolve()
        })
        .catch(() =>  reject())
    })
  }
}
